import { ContactPersonManager } from '@ayocore/erp/crm/client/components/ContactPersonManager';
import type { ContactPerson } from '../../../../../schemas/contact-person.schema';

interface PartnerContactPersonsProps {
  entityId: number;
  entityType: 'crm::PartnerRepository' | 'crm::LeadRepository';
  contactPersons: (ContactPerson & { is_primary?: boolean; is_active?: boolean; role?: string })[];
  onContactPersonsChanged: () => void;
  /** Показать всех контактных лиц, а не только основных */
  showAll?: boolean;
  /** Показать поле поиска */
  showSearch?: boolean;
}

export function PartnerContactPersons({
  entityId,
  entityType,
  contactPersons,
  onContactPersonsChanged,
  showAll,
  showSearch,
}: PartnerContactPersonsProps) {
  return (
    <ContactPersonManager
      entityId={entityId}
      entityType={entityType}
      contactPersons={contactPersons}
      onContactPersonsChanged={onContactPersonsChanged}
      showAll={showAll}
      showSearch={showSearch}
    />
  );
}
